import LogoIcon from "./LogoIcon";

export default LogoIcon;

export * from "./LogoIcon";
